// extracted by mini-css-extract-plugin
module.exports = {"h5sdk":"index_h5sdk_whSOm","gameFrame":"index_gameFrame_3wUzF","mask":"index_mask_1juWc","outer":"index_outer_3K2aQ","captcha":"index_captcha_1GIPk"};